import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { RefreshCw, Loader2 } from "lucide-react";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

const fetchRandomJoke = async () => {
  // Get random joke using a random offset
  const { count } = await supabase
    .from('dev_jokes')
    .select('*', { count: 'exact', head: true });

  if (!count || count === 0) {
    // Fallback jokes if database is empty
    const fallbackJokes = [
      { joke: "Why do developers use dark mode? Because bugs are attracted to light.", joke_type: "dad" },
      { joke: "A SQL query walks into a bar, walks up to two tables and asks... 'Can I JOIN you?'", joke_type: "dad" },
      { joke: "How many programmers does it take to change a light bulb? None. It's a hardware problem.", joke_type: "silly" },
    ];
    return fallbackJokes[Math.floor(Math.random() * fallbackJokes.length)];
  }

  const randomOffset = Math.floor(Math.random() * count);

  const { data, error } = await supabase
    .from('dev_jokes')
    .select('*')
    .range(randomOffset, randomOffset)
    .limit(1)
    .single();

  if (error) throw error;
  return data;
};

export const DevHumorWidget = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const { data: joke, isLoading } = useQuery({
    queryKey: ['random-joke', refreshKey],
    queryFn: fetchRandomJoke,
    staleTime: 0, // Always fetch fresh
  });

  const getNewJoke = () => {
    setRefreshKey(prev => prev + 1);
  };

  useEffect(() => {
    // Fetch initial joke on mount
    getNewJoke();
  }, []);

  return (
    <Card className="hover-lift w-full max-w-full">
      <CardHeader>
        <CardTitle className="flex items-center justify-between gap-2">
          <span className="break-words">Random Dev Humor</span>
          <Button
            variant="ghost"
            size="icon"
            onClick={getNewJoke}
            disabled={isLoading}
            className="h-8 w-8 flex-shrink-0"
          >
            {isLoading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <RefreshCw className="h-4 w-4" />
            )}
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center py-2">
            <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
          </div>
        ) : (
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground italic break-words">
              {joke?.joke || "Loading jokes..."}
            </p>
            {joke?.joke_type && (
              <p className="text-xs text-muted-foreground/60 capitalize">
                {joke.joke_type} joke
              </p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
